import { InputConfig, Typography } from "@cpj-ai/panel-npm-package";
import { usePostHiringStore } from "@store/usePostHiringStore";
import dayjs from "dayjs";
import { useCallback } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { ICertifiedDocument } from "..";
import CertificateStatusBadge from "./CertificateStatusBadge";

export type TCertificateStatus = "VERIFIED" | "NOT_VERIFIED" | "VERIFIED_BY_JOB_SEEKER" | "REJECTED";

export type FormGridContainerProps<T extends FieldValues = FieldValues> = {
  formHandler: UseFormReturn<T>;
  inputConfigs: InputConfig[];
  gridColumnSize?: number;
  previewMode?: boolean;
};

const CertifiedDocumentCard = ({ title, issuer, date, status, file, link }: ICertifiedDocument) => {
  const { setSelectedCertificate } = usePostHiringStore();

  const getCardContainerBgClass = () => {
    switch (status) {
      case "VERIFIED":
        return "bg-green-100";
      case "NOT_VERIFIED":
        return "bg-[#FEFCE8]";
      case "VERIFIED_BY_JOB_SEEKER":
        return "bg-cyan-100";
      case "REJECTED":
        return "bg-red-100";
      default:
        return "bg-zinc-100";
    }
  };

  const handleClickOnCertificate = useCallback(() => {
    setSelectedCertificate({ title, issuer, date, status, file, link });
  }, [date, file, issuer, setSelectedCertificate, status, title, link]);

  return (
    <div
      className={`rounded-lg cursor-pointer p-2.5 border-zinc-200 border-1 h-full ${getCardContainerBgClass()}`}
      onClick={handleClickOnCertificate}
    >
      <Typography className="text-sm font-semibold leading-5">{title}</Typography>
      <Typography className="!text-[11px]">{issuer}</Typography>
      <Typography className="!text-[11px] italic text-zinc-700">{`${date?.from ? dayjs(date?.from).format("MMM YYYY") : "Current"} - ${date?.to ? dayjs(date?.to).format("MMM YYYY") : "Current"}`}</Typography>
      <CertificateStatusBadge status={status} />
    </div>
  );
};

export default CertifiedDocumentCard;
